<template>
  <div id="wrap">
    <v-container id="message-container-wrap">
      <v-row no-gutters>
        <v-col sm="4"></v-col>
        <v-col id="message-container" sm="4">
          <v-card class="mx-auto" :loading="isLoading">
            <v-card-text>
              <p class="display-1 text--primary">
                Maximizer Connector
              </p>
              <div>
                Environment
              </div>
              <div class="text-subtitle-1 text--primary text-capitalize">
                {{ environmentFormatted }}
              </div>
              <div class="mt-3">
                Connection Status
              </div>
              <div class="text-subtitle-1 text--primary">
                {{ connectionStatus }}
              </div>
              <div class="mt-3">
                {{ messageLabel }}
              </div>
              <div
                class="text-subtitle-1"
                :class="[isError ? 'red--text' : 'text--primary']"
              >
                {{ message }}
              </div>
            </v-card-text>
            <v-card-actions v-show="environment">
              <v-spacer></v-spacer>
              <v-btn
                color="green"
                class="white--text mr-2 mb-2"
                @click="redirectToSystemx"
                >back to systemx</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col sm="4"></v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Maximizer',
  data() {
    return {
      code: '',
      isError: false,
      isLoading: true,
      connectionId: 0,
      environment: null,
      databaseName: '',
      serverPrefix: process.env.VUE_APP_SERVER_PREFIX,
      serverAddress: process.env.VUE_APP_SERVER_ADDRESS,
      connectionStatus: '-',
      message: 'Processing',
    };
  },
  created() {
    const urlParams = this.$route.query;
    try {
      this.parseConnectionParams(urlParams);
    } catch (error) {
      this.isLoading = false;
      this.isError = true;
      this.message = error;
    }
  },
  computed: {
    environmentFormatted() {
      if (this.environment == null) {
        return '-';
      }
      return this.environment;
    },
    messageLabel() {
      if (this.isError) {
        return 'Error Message';
      }
      return 'Message';
    },
  },
  methods: {
    parseConnectionParams(urlParams) {
      if (urlParams.code == null || urlParams.state == null) {
        throw 'Connection parameters are missing';
      }
      if (urlParams.code == '' || urlParams.state == '') {
        throw 'Connection parameters are empty';
      }

      const decodedStateArr = atob(urlParams.state).split(';;');
      if (decodedStateArr.length != 2) {
        throw 'Invalid connection parameters passed';
      }

      this.connectionId = decodedStateArr[0];
      this.environment = decodedStateArr[1];
      this.code = urlParams.code;
      this.databaseName = urlParams.login_hint.split(' ')[1];

      this.authorizeConnection();
    },
    async authorizeConnection() {
      this.$api.setSxEnvironment(this.environment);

      try {
        const res = await this.$api.get(
          `maximizer-connections/authorize/${this.connectionId}/${this.code}/${this.databaseName}`
        );
        this.isLoading = false;
        if (res.status === 200) {
          this.isError = false;
          this.connectionStatus = 'Connected';
          this.message =
            "Connection established. Please refresh your SystemX 'Maximizer Connections' page.";
        }
      } catch (error) {
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
    redirectToSystemx() {
      window.location = `${this.serverPrefix}${this.environment}.${this.serverAddress}/admins?page=maximizer`;
    },
  },
};
</script>

<style scoped>
#wrap {
  height: 100%;
  background-color: #2e2e2e;
}
#message-container-wrap {
  margin-top: 10%;
}
</style>
